// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"62d96f02","453":"a4c98c57","455":"70a6b672","977":"25a837f5"}[chunkId] + ".chunk.js";
};